var allPolygons = [];

$(function() {
	initialize();

	$(el('editRep')).on('click', function() {
		editRep();
	});

	$('.editRepModal .save').on('click', function() {
		saveRepData();
	});

	$('.editRepModal input,.editRepModal textarea').on('keyup',function(){
		// Update matching field

		var field = $(this).data('field');
		$('.load ' + field).text($(this).val());
	});

	if($('.editRepModal').length > 0)
	{
		loadImageUpload();
	}

});

function editRep()
{
	// Gather data to edit
	var repData = {};
	repData.image = $('.load img').prop('src');
	repData.title = $('.load h2').text();
	repData.address = $('.load .address').text();
	repData.phone = $('.load .phone').text();
	repData.email = $('.load .email').text();
	repData.text = $('.load .description').text();

	var repModal = $('.editRepModal');
  repModal.find('.original').attr('src',repData.image);
  repModal.find('.edtTitle').val(repData.title);
  repModal.find('.edtAddress').val(repData.address);
  repModal.find('.edtPhone').val(repData.phone);
  repModal.find('.edtEmail').val(repData.email);
  repModal.find('.edtText').text(repData.text);

	repModal.modal();
	centerPopups();
}

function initialize() {
  // Styles
  var styles = [
    { "featureType": "road", "stylers": [ { "visibility": "off" } ]},
    {
        "featureType": "landscape.natural.terrain",
        "stylers": [
            { "visibility": "off" }
        ]
    },{
        "featureType": "landscape.natural.landcover",
        "stylers": [
            { "visibility": "off" }
        ]
    },{
        "featureType": "poi.park",
        "stylers": [
            { "visibility": "off" }
        ]
    }
  ];

  // Map Center
  var myLatLng = new google.maps.LatLng(50.5978700, 4.3285100);

  // Set map zoom
  var iZoomValue = 8;
  if($(window).width() < 768) {
    iZoomValue = 6;
  }

  // General Options
  var mapOptions = {
    zoom: iZoomValue,
    center: myLatLng,
    mapTypeId: google.maps.MapTypeId.RoadMap,
    styles: styles,
    scaleControl: false,
    scrollwheel: false,
    mapTypeControl: false
  };
  var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  if(typeof reps !== 'undefined')
  {
    for (var i = 0; i < reps.length; i++) {

      var points = [];
      for (var e = 0; e < reps[i].polygon.length; e++) {
        var latLng = new google.maps.LatLng(reps[i].polygon[e].lat,reps[i].polygon[e].long);
        points.push(latLng);
      }

      var repArea = new google.maps.Polygon({
        paths: points,
        strokeColor: '#54b948',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#54b948',
        fillOpacity: 0.5,
        indexID: i
      });
      repArea.setMap(map);
      allPolygons.push(repArea);
      google.maps.event.addListener(repArea, 'click', function(event) {
        clickArea(this);
      });
      google.maps.event.addListener(repArea, 'mouseover', function (event) {
          this.setOptions({
              strokeColor: '#007D52',
              fillColor: '#007D52'
          });
      });

      google.maps.event.addListener(repArea, 'mouseout', function (event) {
          if(typeof this.selected !== 'undefined'){
            if(!this.selected)
            {
              this.setOptions({
                  strokeColor: '#54b948',
                  fillColor: '#54b948'
              });
            }
          }
          else
          {
              this.setOptions({
                  strokeColor: '#54b948',
                  fillColor: '#54b948'
              });
          }
      });
    }
  }
}

var clickArea = function(polygon) {
    $('.modal.repPopup').remove();
    $('#editRep').removeClass('hidden');

    for (var i = 0; i < allPolygons.length; i++) {
      allPolygons[i].selected = false;
      allPolygons[i].setOptions({
          strokeColor: '#54b948',
          fillColor: '#54b948'
        });
    };

    polygon.setOptions({
      strokeColor: '#007D52',
      fillColor: '#007D52'
    });
    polygon.selected = true;
    var repData = '';
    if (reps[polygon.indexID].image !== '') {
      repData += '<img src="' + reps[polygon.indexID].image + '" alt="' + reps[polygon.indexID].name + '" title="' + reps[polygon.indexID].name + '" />'
    }
    repData += '<h2>' + reps[polygon.indexID].name + '</h2><span class="address">' + reps[polygon.indexID].address + '</span><br><br><span class="phone">' + reps[polygon.indexID].phone + '</span><br><span class="email">' +
      reps[polygon.indexID].email + '</span><br><br></div>';
    repData += '<input type="hidden" class="repId" value="' + reps[polygon.indexID]._id + '" />'
    $('.repContent .load').html(repData);
}

function loadImageUpload()
{
 var uploadContainer = $('.editRepModal');
 var uploader        = uploadContainer.find('.imageUpload');
 var uploadResult    = uploadContainer.find('.uploadResult');
 var uploadLoader    = uploadContainer.find('.uploadLoader');

 var imageWrapper    = uploadContainer.find('.imagewrapper');
 var original        = imageWrapper.find('.original');

  uploader.toggleClass('hide');

  // Dropzone
  if(!uploader.hasClass('dz-clickable'))
  {
    uploader.dropzone({
      url: "/index.cfm/content/ajax/upload/content",
      success: function(file,oData){
        var imageSource = imagePathContent + oData.fileName;

        original.attr('src',imageSource);
        imageWrapper.toggleClass('hide');
        uploadResult.toggleClass('hide');
        uploadLoader.toggleClass('hide');
      },
      drop: function(){
        uploader.addClass('hide');
        uploadLoader.toggleClass('hide');
        uploader.closest('.panel').find('.editDone').addClass('hide');
      }
    });
  }
}

function saveRepData()
{
  uAjax = "/index.cfm/shop/ajax/saverepdata";
  // Gather data in JSON
  var repData = {};
  repData._id = $('.repId').val();
  repData.name = $('.editRepModal .edtTitle').val();
  repData.address = $('.editRepModal .edtAddress').val();
  repData.phone = $('.editRepModal .edtPhone').val();
  repData.email = $('.editRepModal .edtEmail').val();
  repData.image = $('.editRepModal .original').attr('src');

  var oCall = callAjax("saverepdata", repData, "post");

  // process feedback
  oCall.success(function(oData)
  {
    if(oData.errorType == '')
    {
      $('.editRepModal').modal('hide');
    }
    else
    {
      // show error message
      showAlert('error', oData.errorMessage, oData.errorUnhandled);
    }
  });
}